import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  div: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    boxSizing: 'border-box',
    minHeight: 0,
    minWidth: 0,
  },
});



// WEBPACK FOOTER //
// ./src/ui/view/styles.js